<template>
  <menu class="user-menu">
    <header class="user-menu__header">
      <img class="user-menu__avatar" :src="avatar" alt="">
      <div class="user-menu__header-box">
        <h1 class="user-menu__username">{{name}} {{firstname}}</h1>
        <ul class="user-menu__user-rtu">
          <li>Administrateur EXOPERA</li>
          <li>Rédacteur</li>
        </ul>
      </div>
    </header>
    <main class="user-menu__main">
      <router-link to="/" tag="span">
        <div class="user-menu__main-box u-pointer" :class="{'user-menu__main-box--bgcolor': isDashboardSelected}" @mouseover="isDashboardSelected = true" @mouseout="isDashboardSelected = false">
          <h3 class="user-menu__nav" :class="{'u-color-white': isDashboardSelected}">Tableau de bord</h3>
          <svg class="user-menu__icon--small" :class="{'user-menu__icon--white': isDashboardSelected}">
            <use href="../assets/sprite.svg#icon-th-large"></use>
          </svg>
        </div>
      </router-link>

      <router-link v-if="$can('read', 'groupabilities')" to="/parameters/users" tag="div">
        <div class="user-menu__main-box u-pointer" :class="{'user-menu__main-box--bgcolor': isAdminUsersSelected}" @mouseover="isAdminUsersSelected = true" @mouseout="isAdminUsersSelected = false">
          <h3 class="user-menu__nav" :class="{'u-color-white': isAdminUsersSelected}">Administrer les utilisateurs</h3>
          <svg class="user-menu__icon--small" :class="{'user-menu__icon--white': isAdminUsersSelected}">
            <use href="../assets/sprite.svg#icon-group"></use>
          </svg>
        </div>
      </router-link>

      <router-link v-if="$can('read', 'groupabilities')" to="/parameters/groupability" tag="div">
        <div class="user-menu__main-box u-pointer" :class="{'user-menu__main-box--bgcolor': isAclSelected}" @mouseover="isAclSelected = true" @mouseout="isAclSelected = false">
          <h3 class="user-menu__nav" :class="{'u-color-white': isAclSelected}">Gérer les droits d'accès</h3>
          <svg class="user-menu__icon--small" :class="{'user-menu__icon--white': isAclSelected}">
            <use href="../assets/sprite.svg#icon-lock"></use>
          </svg>
        </div>
      </router-link>

       <router-link v-if="$can('read', 'users')" to="/photo" tag="div">
        <div class="user-menu__main-box u-pointer" :class="{'user-menu__main-box--bgcolor': isPhotoSelected}" @mouseover="isPhotoSelected = true" @mouseout="isPhotoSelected = false">
          <h3 class="user-menu__nav" :class="{'u-color-white': isPhotoSelected}">Gérer les photos</h3>
          <svg class="user-menu__icon--small" :class="{'user-menu__icon--white': isPhotoSelected}">
            <use href="../assets/sprite.svg#icon-camera"></use>
          </svg>
        </div>
      </router-link>

      <div class="user-menu__main-box u-pointer" :class="{'user-menu__main-box--bgcolor': isSignOutSelected}" @mouseover="isSignOutSelected = true" @mouseout="isSignOutSelected = false" @click="logout()">
        <h3 class="user-menu__nav" :class="{'u-color-white': isSignOutSelected}">{{ $t('usermenu.logout') }}</h3>
        <svg class="user-menu__icon--small" :class="{'user-menu__icon--white': isSignOutSelected}">
          <use href="../assets/sprite.svg#icon-power-off"></use>
        </svg>
      </div>
    </main>
    <footer class="user-menu__footer">
      <router-link to="/parameters" tag="span">
        <div class="user-menu__footer-box u-pointer" :class="{'user-menu__footer-box--bgcolor': isParametersSelected}" @mouseover="isParametersSelected = true" @mouseout="isParametersSelected = false">
          <svg class="user-menu__icon--large" :class="{'user-menu__icon--white': isParametersSelected}">
            <use href="../assets/sprite.svg#icon-cogs"></use>
          </svg>
          <span :class="{'u-color-white': isParametersSelected}">{{ $t('usermenu.parameters') }}</span>
        </div>
      </router-link>
      <div class="user-menu__footer-box u-pointer" :class="{'user-menu__footer-box--bgcolor': isSupportContactSelected}" @mouseover="isSupportContactSelected = true" @mouseout="isSupportContactSelected = false">
        <svg class="user-menu__icon--large" :class="{'user-menu__icon--white': isSupportContactSelected}">
          <use href="../assets/sprite.svg#icon-envelope-open-o"></use>
        </svg>
        <span :class="{'u-color-white': isSupportContactSelected}">{{ $t('usermenu.contact') }}</span>
      </div>
    </footer>
  </menu>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: userStoreGetters } = createNamespacedHelpers('user')
const { mapActions: authStoreActions } = createNamespacedHelpers('auth')

export default {
  data: function () {
    return {
      isDashboardSelected: false,
      isAdminUsersSelected: false,
      isAclSelected: false,
      isSignOutSelected: false,
      isParametersSelected: false,
      isSupportContactSelected: false,
      isPhotoSelected: false
    }
  },
  computed: {
    ...userStoreGetters({
      avatar: 'getAvatar',
      name: 'getUserName',
      firstname: 'getUserFirstname'
    })
  },
  methods: {
    ...authStoreActions({
      setLogout: 'LOGOUT'
    }),
    logout () {
      this.setLogout()
    }
  }
}
</script>
